import { createConsumer } from '@rails/actioncable'

const cableUrl = `${import.meta.env.VITE_MASTERMIND_API}/cable`
export const consumer = createConsumer(cableUrl)
